import {isNil, isNotNil} from 'ramda';

import {useGetBranchQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {
  useChangeWorkshopInterestBranchMutation,
  useGetWorkshopInterestQuery,
} from '@dms/api/workshop';

import {TestIdProps} from 'shared/web';

import {useWorkshopInterestEditPermissions} from '../../../hooks/useWorkshopInterestEditPermissions';
import {handleApiError} from '../../../utils/handleApiError';
import {BranchChanger} from './BranchChanger';

export interface WorkshopInterestBranchProps extends TestIdProps {
  recordId: string;
}

export function WorkshopInterestBranch(props: WorkshopInterestBranchProps) {
  const {data: workshopInterest} = useGetWorkshopInterestQuery({id: props.recordId});
  const {data: currentUserInfo} = useGetCurrentUserInfoQuery();

  const {hasChangeBranchPermission} = useWorkshopInterestEditPermissions({
    interestId: props.recordId,
  });

  const [changeBranch] = useChangeWorkshopInterestBranchMutation();

  const userAccessibleBranch = currentUserInfo?.branches?.find(
    (branch) => branch.id === workshopInterest?.branchId
  );

  const {data: branchById} = useGetBranchQuery(
    {branchId: workshopInterest?.branchId ?? ''},
    {skip: isNil(workshopInterest?.branchId) || isNotNil(userAccessibleBranch)}
  );

  const activeBranch = userAccessibleBranch ?? branchById;

  const handleBranchChange = (branchId: string) =>
    changeBranch({
      id: props.recordId,
      changeWorkshopInterestBranchRequestBody: {
        branchId,
      },
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <BranchChanger
      recordId={props.recordId}
      activeBranch={activeBranch}
      onChange={handleBranchChange}
      isEditDisabled={!hasChangeBranchPermission}
      data-testid={props['data-testid']}
    />
  );
}
